import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8888';

let socket = null;
let subscriberCount = 0;
let connectedUserKey = null;

export const connectSocket = ({ userId, role } = {}) => {
    if (!userId) return null;

    const userKey = `${userId}:${role || ''}`;
    if (socket && connectedUserKey === userKey) {
        subscriberCount += 1;
        return socket;
    }

    if (socket) {
        socket.disconnect();
    }

    socket = io(SOCKET_URL, {
        query: { userId, role },
        transports: ['websocket', 'polling']
    });
    connectedUserKey = userKey;
    subscriberCount = 1;

    return socket;
};

export const releaseSocket = () => {
    subscriberCount = Math.max(0, subscriberCount - 1);

    if (subscriberCount === 0 && socket) {
        socket.disconnect();
        socket = null;
        connectedUserKey = null;
    }
};

export const getSocket = () => socket;
